import React from 'react'
import classNames from 'classnames'
import {useDealStateContext} from 'Src/contexts/DealContext'
import {PROGRESS_STATE} from 'Src/contexts/ProgressContext'
import {useProgressStateContext} from 'Src/contexts/ProgressContext'
import {getBreadcrumbProgressState} from 'Src/utilities/Helpers'

interface ProgressSegmentProps {
  type: string
}

const ProgressSegment: React.FC<ProgressSegmentProps> = ({type}: ProgressSegmentProps) => {
  const progress = useProgressStateContext()
  const {dealType} = useDealStateContext()
  const progressState = getBreadcrumbProgressState(dealType, progress, type)
  const isProgressTouched = [PROGRESS_STATE.started, PROGRESS_STATE.complete].includes(
    progressState
  )

  return (
    <div
      className={classNames('tw-z-0 tw-mb-2 tw-h-1 tw-w-1/3 sm:tw-h-1/3 sm:tw-w-1', {
        'tw-bg-brand-breadcrumbs__path--touched': isProgressTouched,
        'tw-bg-brand-breadcrumbs__path--untouched': !isProgressTouched,
      })}
      data-testid={type}
    />
  )
}

export default ProgressSegment
